module.exports = {
  websocket: {
    key: 'websocket',
    label: 'Websocket',
  },
  polling: {
    key: 'polling',
    label: 'Polling',
  },
};